(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    (() => {
    const controllers = new Map();

    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );

    function configure(marker) {
      const slideshow = marker.closest('slideshow-component');

      if (!slideshow || !slideshow.isConnected) return;

      if (
        typeof slideshow.play !== 'function' ||
        typeof slideshow.pause !== 'function' ||
        typeof slideshow.suspend !== 'function'
      ) {
        return;
      }

      controllers.get(slideshow)?.();
      slideshow.suspend();

      const ownSlides = Array.from(
        slideshow.querySelectorAll('slideshow-slide')
      ).filter(
        slide => slide.closest('slideshow-component') === slideshow
      );

      const nativeControls = Array.from(
        slideshow.querySelectorAll(
          '.slideshow-control.icon-pause, .slideshow-control.icon-play'
        )
      ).filter(
        control => control.closest('slideshow-component') === slideshow
      );

      const rawSeconds = Number(marker.dataset.autoplaySeconds);

      const seconds = Number.isFinite(rawSeconds)
        ? Math.max(2, Math.min(15, rawSeconds))
        : 5;

      const enabled =
        marker.dataset.autoplay === 'true' &&
        ownSlides.length > 1 &&
        !reducedMotion.matches;

      let toggle;
      let observer;

      nativeControls.forEach(control => {
        control.style.display = enabled ? '' : 'none';
      });

      if (enabled) {
        slideshow.setAttribute('autoplay', String(seconds));

        if (!nativeControls.length) {
          toggle = document.createElement('button');
          toggle.type = 'button';
          toggle.className = 'ts-slideshow-autoplay-toggle';

          slideshow.appendChild(toggle);

          toggle.addEventListener('click', () => {
            if (slideshow.hasAttribute('paused')) {
              slideshow.play();
            } else {
              slideshow.pause();
            }
          });
        }

        const syncControls = () => {
          const paused = slideshow.hasAttribute('paused');

          slideshow.setAttribute(
            'aria-live',
            paused ? 'polite' : 'off'
          );

          if (toggle) {
            toggle.textContent = paused
              ? 'Play slideshow'
              : 'Pause slideshow';

            toggle.setAttribute(
              'aria-label',
              toggle.textContent
            );
          }
        };

        observer = new MutationObserver(syncControls);

        observer.observe(slideshow, {
          attributes: true,
          attributeFilter: ['paused']
        });

        slideshow.play();
        syncControls();
      } else {
        slideshow.removeAttribute('autoplay');
        slideshow.pause();
        slideshow.setAttribute('aria-live', 'polite');
      }

      const onFocus = event => {
        if (
          enabled &&
          event.target !== toggle &&
          !nativeControls.includes(event.target)
        ) {
          slideshow.pause();
        }
      };

      const onMotionChange = () => configure(marker);

      slideshow.addEventListener('focusin', onFocus);

      reducedMotion.addEventListener(
        'change',
        onMotionChange
      );

      controllers.set(slideshow, () => {
        observer?.disconnect();
        toggle?.remove();

        slideshow.removeEventListener(
          'focusin',
          onFocus
        );

        reducedMotion.removeEventListener(
          'change',
          onMotionChange
        );

        slideshow.suspend();
        controllers.delete(slideshow);
      });
    }

    async function initialise(root = document) {
      await customElements.whenDefined('slideshow-component');

      requestAnimationFrame(() => {
        if (root !== document && !root.isConnected) return;

        root
          .querySelectorAll('[data-ts-slideshow-controller]')
          .forEach(configure);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => initialise(),
        { once: true }
      );
    } else {
      initialise();
    }

    document.addEventListener(
      'shopify:section:load',
      event => initialise(event.target)
    );

    document.addEventListener(
      'shopify:section:unload',
      event => {
        controllers.forEach((cleanup, slideshow) => {
          if (event.target.contains(slideshow)) {
            cleanup();
          }
        });
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
